module.exports = {
  "mode": "compressed",
  "staticDomainPrefix": "//static.hsappstatic.net",
  "bender": {
    "depVersions": {
      "conversations-embed": "static-1.21486",
      "conversations-internal-schema": "static-1.10251",
      "head-dlb": "static-1.2601",
      "hs-test-utils": "static-1.5609",
      "hubspot-url-utils": "static-1.2086",
      "HubStyleTokens": "static-2.9162",
      "I18n": "static-7.1304",
      "jasmine-runner": "static-1.3978",
      "quartz": "static-1.4174",
      "react": "static-7.133",
      "sinon": "static-1.9",
      "webpack-env": "static-1.41",
      "isMobile": "static-1.7",
      "StyleGuideUI": "static-3.434",
      "enviro": "static-4.275",
      "hs-promise-rejection-tracking": "static-1.2994",
      "PortalIdParser": "static-2.254",
      "raven": "static-3.3326",
      "raven-hubspot": "static-1.3633",
      "bend-plugin-trellis-migration": "static-1.1205",
      "moment": "static-3.26",
      "immutable": "static-2.19",
      "quartz-core": "static-1.3393",
      "transmute": "static-2.29",
      "HeadJS": "static-2.519",
      "react-dom": "static-7.85",
      "foundations-components": "static-1.4405",
      "framer-motion": "static-1.31",
      "hs-test-utils-bend-plugin": "static-1.720",
      "msw": "static-1.39",
      "react-redux": "static-7.16",
      "redux": "static-4.16",
      "testing-library": "static-1.114",
      "i18n-data": "static-1.189",
      "metrics-js": "static-1.7218",
      "moment-timezone": "static-5.17",
      "react-utils": "static-2.3273",
      "jasmine": "static-4.1891",
      "quartz-core-utils": "static-1.1041",
      "csstype": "static-1.8",
      "copilot-toolkit": "static-1.2878",
      "dispatcher": "static-1.106",
      "general-store": "static-6.20",
      "history": "static-4.15",
      "hub-http": "static-1.2732",
      "hub-http-janus": "static-1.587",
      "hub-http-shared-msw-handlers": "static-1.5511",
      "hubspotter-http": "static-1.2621",
      "hubspotter-http-shared-msw-handlers": "static-1.5509",
      "icons": "static-2.585",
      "mobile-manifest-mixins": "static-1.290",
      "platform-navigation-bootstrap": "static-1.9446",
      "quick-fetch": "static-1.1826",
      "react-rhumb": "static-1.14133",
      "react-router-dom": "static-5.26",
      "styled-components": "static-2.40",
      "ui-fonts": "static-1.327",
      "UIComponents": "static-3.6112",
      "bend-plugin-foundations-components": "static-1.673",
      "floating-ui": "static-1.21",
      "foundations-assets": "static-1.2386",
      "foundations-theming": "static-1.1570",
      "hs-story-utils": "static-1.6624",
      "react-aria": "static-1.33",
      "react-select-plus": "static-1.65",
      "react-virtualized": "static-2.68",
      "tanstack-table": "static-1.10",
      "ui-images": "static-2.766",
      "hoist-non-react-statics": "static-3.9",
      "chatspot-client-types": "static-1.6802",
      "chatspot-core": "static-1.12016",
      "ts-schema": "static-1.2013",
      "sassPrefix": "static-1.122",
      "platform-infra-nav-components": "static-1.5725",
      "classnames": "static-2.10",
      "cssUtils": "static-1.321",
      "HubStyle": "static-2.9472",
      "bend-plugin-foundations-theming": "static-1.53",
      "foundations-theming-base": "static-1.555",
      "react-input-autosize": "static-2.17",
      "hs-lodash": "static-4.9"
    },
    "depPathPrefixes": {
      "conversations-embed": "/conversations-embed/static-1.21486",
      "conversations-internal-schema": "/conversations-internal-schema/static-1.10251",
      "head-dlb": "/head-dlb/static-1.2601",
      "hs-test-utils": "/hs-test-utils/static-1.5609",
      "hubspot-url-utils": "/hubspot-url-utils/static-1.2086",
      "HubStyleTokens": "/HubStyleTokens/static-2.9162",
      "I18n": "/I18n/static-7.1304",
      "jasmine-runner": "/jasmine-runner/static-1.3978",
      "quartz": "/quartz/static-1.4174",
      "react": "/react/static-7.133",
      "sinon": "/sinon/static-1.9",
      "webpack-env": "/webpack-env/static-1.41",
      "isMobile": "/isMobile/static-1.7",
      "StyleGuideUI": "/StyleGuideUI/static-3.434",
      "enviro": "/enviro/static-4.275",
      "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.2994",
      "PortalIdParser": "/PortalIdParser/static-2.254",
      "raven": "/raven/static-3.3326",
      "raven-hubspot": "/raven-hubspot/static-1.3633",
      "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.1205",
      "moment": "/moment/static-3.26",
      "immutable": "/immutable/static-2.19",
      "quartz-core": "/quartz-core/static-1.3393",
      "transmute": "/transmute/static-2.29",
      "HeadJS": "/HeadJS/static-2.519",
      "react-dom": "/react-dom/static-7.85",
      "foundations-components": "/foundations-components/static-1.4405",
      "framer-motion": "/framer-motion/static-1.31",
      "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.720",
      "msw": "/msw/static-1.39",
      "react-redux": "/react-redux/static-7.16",
      "redux": "/redux/static-4.16",
      "testing-library": "/testing-library/static-1.114",
      "i18n-data": "/i18n-data/static-1.189",
      "metrics-js": "/metrics-js/static-1.7218",
      "moment-timezone": "/moment-timezone/static-5.17",
      "react-utils": "/react-utils/static-2.3273",
      "jasmine": "/jasmine/static-4.1891",
      "quartz-core-utils": "/quartz-core-utils/static-1.1041",
      "csstype": "/csstype/static-1.8",
      "copilot-toolkit": "/copilot-toolkit/static-1.2878",
      "dispatcher": "/dispatcher/static-1.106",
      "general-store": "/general-store/static-6.20",
      "history": "/history/static-4.15",
      "hub-http": "/hub-http/static-1.2732",
      "hub-http-janus": "/hub-http-janus/static-1.587",
      "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.5511",
      "hubspotter-http": "/hubspotter-http/static-1.2621",
      "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.5509",
      "icons": "/icons/static-2.585",
      "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.290",
      "platform-navigation-bootstrap": "/platform-navigation-bootstrap/static-1.9446",
      "quick-fetch": "/quick-fetch/static-1.1826",
      "react-rhumb": "/react-rhumb/static-1.14133",
      "react-router-dom": "/react-router-dom/static-5.26",
      "styled-components": "/styled-components/static-2.40",
      "ui-fonts": "/ui-fonts/static-1.327",
      "UIComponents": "/UIComponents/static-3.6112",
      "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.673",
      "floating-ui": "/floating-ui/static-1.21",
      "foundations-assets": "/foundations-assets/static-1.2386",
      "foundations-theming": "/foundations-theming/static-1.1570",
      "hs-story-utils": "/hs-story-utils/static-1.6624",
      "react-aria": "/react-aria/static-1.33",
      "react-select-plus": "/react-select-plus/static-1.65",
      "react-virtualized": "/react-virtualized/static-2.68",
      "tanstack-table": "/tanstack-table/static-1.10",
      "ui-images": "/ui-images/static-2.766",
      "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
      "chatspot-client-types": "/chatspot-client-types/static-1.6802",
      "chatspot-core": "/chatspot-core/static-1.12016",
      "ts-schema": "/ts-schema/static-1.2013",
      "sassPrefix": "/sassPrefix/static-1.122",
      "platform-infra-nav-components": "/platform-infra-nav-components/static-1.5725",
      "classnames": "/classnames/static-2.10",
      "cssUtils": "/cssUtils/static-1.321",
      "HubStyle": "/HubStyle/static-2.9472",
      "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.53",
      "foundations-theming-base": "/foundations-theming-base/static-1.555",
      "react-input-autosize": "/react-input-autosize/static-2.17",
      "hs-lodash": "/hs-lodash/static-4.9"
    },
    "project": "conversations-embed",
    "staticDomain": "//static.hsappstatic.net",
    "staticDomainPrefix": "//static.hsappstatic.net"
  }
};